import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import {
  header,
  icons,
  people,
  post,
  SignInImages,
} from "../../config/imagesLink";
import { IoIosArrowDown } from "react-icons/io";
import axios from "../../API/axios";
import {
  getConnectionList,
  getRecommendationList,
  getShortMutualUserInfo,
} from "../../Services/apiService";
import { ShimmerThumbnail } from "react-shimmer-effects";
import CircleIcon from '@mui/icons-material/Circle';

import { useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { ShimmerDiv } from "@skeleton";
import SearchSharpIcon from '@mui/icons-material/SearchSharp';
import MoreHorizSharpIcon from '@mui/icons-material/MoreHorizSharp';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import MailOutlineSharpIcon from '@mui/icons-material/MailOutlineSharp';
import PersonSharpIcon from '@mui/icons-material/PersonSharp';
import useChatStore from "../OuterChatBox/useChatStore";
import { onHubEvent, startRealtimeHub } from "../../Services/realtimeHubService";
import { Tooltip } from "@mui/material"; 
import { useTranslation } from "react-i18next";


const RightNavigation = () => {
  const guestModeData = localStorage.getItem("guestMode");
  const { updateChatMessageByID, updateChatReadStatus, updateChatUnreadStatus, updateAllChatReadStatus, addChat, setMessagesList, updateMessages } = useChatStore();
  const { t } = useTranslation();
  const sessionId = localStorage.getItem("sessionId");
  // const [recommendationList, setRecommendationList] = useState([]);
  const [rightRecommendationList, setRightRecommendationList] = useState(() => {
  // const saved = localStorage.getItem("setRecommendationList");
  const saved = localStorage.getItem("rightNavRecommendationList");
  return saved ? JSON.parse(saved) : [];
});

  const [rightRecommendedPage, setRightRecommendedPage] = useState(1);

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [isfollowed, setIsfollowed] = useState(false);
  const language = localStorage.getItem("Lang");

  const [rightSearchUserName, setRightSearchUserName] = useState("");
  const [recomResposne, setRecomResposne] = useState([]); 
  const [rightSearchconnectList, setRightSearchconnectList] = useState(() => {
  // const saved = localStorage.getItem("setConnectionList");
  const saved = localStorage.getItem("rightNevConnectionList");
  return saved ? JSON.parse(saved) : [];
}); 

  //************************ Get Recommendations List  ************************//
  const GetRightRecommendation = async () => {
    try {
      const result = await getRecommendationList({
        pageNumber: 1,
        pageSize: 8,
      });
      const Response = result.data.responseData.viewList; 
      const Response1 = result.data.responseData; 
      setRecomResposne(Response1) 
          localStorage.setItem("rightNavRecommendationList", JSON.stringify(Response));

       if (result.status === 204) {
          setIsError(true)
        } else {
            setRightRecommendationList((prev) => {
              const postSet = new Set(prev.map((post) => post.userUid));
              const uniqueNewPosts = Response.filter(
                (post) => !postSet.has(post.userUid)
              );
              return [...prev, ...uniqueNewPosts];
            });
         }

    } catch (error) {
          setIsError(true)
      console.error("Error fetching data:", error);
    }
  }; 

  // useEffect(() => {
  //   const sessionId = localStorage.getItem("sessionId");
  //   if(sessionId){
  //     GetRecommendation();
  //   }
  // }, [recommendedPage, isfollowed]);

  //************************  Get Recommendations List End  ************************//

  //************************ Connection  List   ************************//
  const [rightLoading, setRightLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [rightPage, setRightPage] = useState(1);
  const [RightConnectionList, setRightConnectionList] = useState([]);
  const [ConnectionListForGuest, setConnectionListForGuest] = useState("");
  const [compListForGuest, setCompListForGuest] = useState("");

  const [isError, setIsError] = useState(false);
  const [isError1, setIsError1] = useState(false);
  const [unauthorisedModal, setUnauthorisedModal] = useState(false);
  const [debouncedrightSearch, setDebouncedrightSearch] = useState(rightSearchUserName);


  // const RightConnectionListAll = async (id) => {
  //   const data = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //     pageNumber: 1,
  //     pageSize: 10,
  //     type: "ConnectionList",
  //     search: debouncedrightSearch,
  //    langKey: language === "en" ? "" : language,

  //   };
  //   try {
  //     const resData = await axios.post("Connection/GetConnectionList", data);
  //     // console.log('resDAta', resData.status);
  //      const Response = resData.data.responseData.viewList;  
  //       localStorage.setItem("rightNevConnectionList", JSON.stringify(Response));
  //     setIsLoading(false);
  //     if (debouncedrightSearch !== "") {
  //       setRightConnectionList([]);
  //       setRightSearchconnectList(resData?.data?.responseData?.viewList);
       
  //     } else {
  //       setRightSearchconnectList([]);
  //       // console.log("resData.data.responseData.viewList", resData);
  //       if (resData.status === 204) {
  //         setIsError(true)
  //       } else {
  //         setRightConnectionList((prev) => {
  //           const newViewList = resData?.data?.responseData?.viewList.filter(
  //             (item) =>
  //               !prev.some((prevItem) => prevItem.cnctnId === item.cnctnId)
  //           );
  //           return [...prev, ...newViewList];
  //         });
  //       }
  //     }
  //   // setIsError(resData?.data?.responseData?.viewList?.length === 0 && rightPage === 1);


  //   } catch (error) {
  //     if (error.response && error.response.status === 404) {
  //       setIsError(true);
  //     } else {
  //       console.log(error);
  //     }
  //     setIsLoading(false);
  //     if ((error.code === 'ERR_NETWORK' && sessionId) || (error.code === "ERR_BAD_REQUEST" && sessionId)) {
  //       setUnauthorisedModal(true)
  //     }
  //   }
  // };

const RightConnectionListAll = async (id) => {
  const data = {
    deviceType: "Web",
    sessionId: sessionId,
    pageNumber: 1,
    pageSize: 10,
    type: "ConnectionList",
    search: debouncedrightSearch,
    langKey: language === "en" ? "" : language,
  };

  try {
    const resData = await getConnectionList(data);

    // ✅ Handle 204 first and RETURN immediately
    if (resData.status === 204) {
      setRightConnectionList([]);
      setRightSearchconnectList([]);
      setIsError1(true);
      setIsLoading(false);
      return; // VERY IMPORTANT
    }

    const viewList = resData?.data?.responseData?.viewList || [];

    localStorage.setItem("rightNevConnectionList", JSON.stringify(viewList));

    setIsLoading(false);

    if (debouncedrightSearch !== "") {
      setRightConnectionList([]);
      setRightSearchconnectList(viewList);
      setIsError1(viewList.length === 0);
    } else {
      setRightSearchconnectList([]);

      setRightConnectionList((prev) => {
        const newViewList = viewList.filter(
          (item) => !prev.some((prevItem) => prevItem.cnctnId === item.cnctnId)
        );
        return [...prev, ...newViewList];
      });

      setIsError1(viewList.length === 0);
    }

  } catch (error) {
    setIsLoading(false);

    if (error.response?.status === 404) {
      setIsError1(true);
    }

    if (
      (error.code === "ERR_NETWORK" && sessionId) ||
      (error.code === "ERR_BAD_REQUEST" && sessionId)
    ) {
      setUnauthorisedModal(true);
    }
  }
};
  
useEffect(() => {
  const handler = setTimeout(() => {
    setDebouncedrightSearch(rightSearchUserName);
  }, 500); // 🔹 500ms debounce delay

  return () => {
    clearTimeout(handler);
  };
}, [rightSearchUserName]);

//   useEffect(() => {
//         const sessionId = localStorage.getItem("sessionId");
// if(sessionId){
//   ConnectionListAll();
// }
//   }, [page, searchUserName]);

  useEffect(() => {
  const sessionId = localStorage.getItem("sessionId");
  if (sessionId) {
    (async () => { 
      await Promise.all([ 
        GetRightRecommendation(), 
      ]);
    })();
  } 
  }, []);

  useEffect(() => {
    const sessionId = localStorage.getItem("sessionId");
    if (sessionId) {
      (async () => { 
        await Promise.all([
          RightConnectionListAll(), 
        ]);
      })();
    } 
  }, [debouncedrightSearch]);

  const ConnectionListAllForGuest = async (id) => {
    try {
      await axios
        .get("UserFollow/GetMostFollowingUser?DeviceType=Web")
        .then((resData) => {
          // console.log("ConnectionListAllForGuest", resData.data.responseData);
          setConnectionListForGuest(resData.data.responseData);
          setIsLoading(false);
          // setConnectionListForGuest((prev) => [
          //   ...prev,
          //   ...resData.data.responseData.viewList,
          // ]);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const ComanpanyListAllForGuest = async (id) => {
    try {
      await axios
        .post("Entity/GetMostFollowedList?DeviceType=Web")
        .then((resData) => {
          // console.log("ComanpanyListAllForGuest====", resData.data.responseData);
          setCompListForGuest(resData.data.responseData);
          setIsLoading(false);
          // setConnectionListForGuest((prev) => [
          //   ...prev,
          //   ...resData.data.responseData.viewList,
          // ]);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (guestModeData) {
      ConnectionListAllForGuest();
      ComanpanyListAllForGuest();
    }
  }, []);
  // console.log("ConnectionList", ConnectionList);
  const handelInfiniteScroll = async () => {
    try {
      if (
        window.innerHeight + document.documentElement.scrollTop + 1 >=
        document.documentElement.scrollHeight
      ) {
        setRightLoading(true);
        setRightPage((prev) => prev + 1);
        setRightRecommendedPage((prev) => prev + 1);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handelInfiniteScroll);
    return () => window.removeEventListener("scroll", handelInfiniteScroll);
  }, []);

  const navigate = useNavigate();

  const navigateConnect = useNavigate();

  const redirectToReceivedTab = () => {
    navigate("/Connections/Recommendations");
  };
  const redirectToConnectionTab = () => {
    navigateConnect("/Connections/Connections");
  };

  //************************Connection List ************************//

  //************************ short mutual list ************************//
  // const [shortMutualList, setShortMutualList] = useState({});
  // console.log('shortMutualList', shortMutualList);

  // useEffect(() => {
  //   if (recommendationList && recommendationList.length > 0) {
  //     recommendationList.forEach((item) => {
  //       fetchShortMutualList(item.userUid);
  //     });
  //   }
  // }, [recommendationList]);

  // const fetchShortMutualList = async (id) => {
  //   // console.log("connect data", id);
  //   const data = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //     userUid: id,
  //   };
  //   try {
  //     const response = await axios.post(
  //       "UserFollow/GetShortMutualUserInfo",
  //       data
  //     );
  //     console.log("responseresponse",response);
      
  //     setShortMutualList((prevState) => ({
  //       ...prevState,
  //       [id]: response.data.responseData,
  //     }));
  //     setIsLoading(false);
  //     // if (response.data.status === "Warning") {
  //     // }
  //   } catch (error) {
  //     console.log(error);

  //     // if (error.response && error.response.status === 404) {
  //     // } else {
  //     //   console.log(error);
  //     // }
  //     setIsLoading(false);
  //   }
  // };

  const [shortMutualList, setShortMutualList] = useState({});
const fetchedUserIds = useRef(new Set()); // keeps track of fetched users

useEffect(() => {
  if (rightRecommendationList && rightRecommendationList.length > 0) {
    rightRecommendationList.forEach((item) => {
      if (!fetchedUserIds.current.has(item.userUid)) {
        fetchedUserIds.current.add(item.userUid);
        fetchShortMutualList(item.userUid);
      }
    });
  }
}, [rightRecommendationList]);

const fetchShortMutualList = async (id) => {
  try {
    const responseData = await getShortMutualUserInfo(id);

    setShortMutualList((prevState) => ({
      ...prevState,
      [id]: responseData,
    }));
  } catch (error) {
    console.log(error);
  } finally {
    setIsLoading(false);
  }
};

const handleProfileImageError = (e) => {
  if (!e || !e.target) return;
  e.target.onerror = null;
  e.target.src = people.DefaultProfile;
};


  //************************ short mutual list ************************//

  const [openDropdown, setOpenDropdown] = useState(null);
  const dropdownRefs = useRef([]);
  const toggleDropdown = (index) => {
    if (openDropdown === index) {
      setOpenDropdown(null);
    } else {
      setOpenDropdown(index);
    }
  };

  const handleClickOutside = (event) => {
    if (
      openDropdown !== null &&
      dropdownRefs.current[openDropdown] &&
      !dropdownRefs.current[openDropdown].contains(event.target)
    ) {
      setOpenDropdown(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openDropdown]);
  const [recommendUserId, setRecommendUserId] = useState("");
  const [isConnected, SetIsConnected] = useState(false);

  // console.log("recommendationList", recommendationList);

  const handleRecommendFollow = (item) => {
    FollowedUser(item.userUid);
    // console.log("item.userUid", item.userUid);
  };

  const handleRecommendConnect = (item) => {
    // console.log("fn run", item.userUid);
    ConnectUser(item.userUid);
  };
  const [connectedId, setConnectedId] = useState("");
  const ConnectUser = async (id) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: id,
      langKey: language === "en" ? "" : language,

    };
    // console.log("connect rs", data);
    try {
      await axios
        .post("Connection/SendConnectionRequest", data)
        .then((resData) => {
          //   toast.success(resData.data.message);
          setToastMessage(resData.data.message);
          setShowToast(true);
          // Remove user from recommendation list immediately so UI updates
          setRightRecommendationList((prev) =>
            prev.filter((item) => item.userUid !== id)
          );
          // Optionally refresh recommendations
          GetRightRecommendation();
          // Mark connected state for UI fallback
          setConnectedId(id);
          SetIsConnected(true);
        });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

   const[showfollowModal,setShowFollowModal]=useState(false);
  
    const handleUnfollowCloseModal = () => {
      setShowFollowModal(false);
      // setSelectedItem(null);
    };
    const handleConfirmAction = () => {
    unFollowUser();
    handleUnfollowCloseModal();
  };


  const [followedId, setFollowedId] = useState("");
  // console.log('isfollowed', isfollowed);
  const FollowedUser = async (id) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: id,
      langKey: language === "en" ? "" : language,

    };
    // console.log("follow before", data);
    try {
      await axios.post("UserFollow/FollowUser", data).then((resData) => {
        // console.log("follow fn after", resData);
        // toast.success(resData.data.message);
        // getUserProfileList();
        setToastMessage(resData.data.message);
        setShowToast(true);
        setRightRecommendationList((prev) =>
          prev.filter((item) => item.userUid !== id)
        );
        GetRightRecommendation();
        setIsfollowed(true);
        // getUserProfile();
        // CheckFollowedUser();
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  // UNFOLLOW USER
const unFollowUser = async () => {
  const data = {
    deviceType: "Web",
    sessionId: sessionId,
    userUID: followedId,
          langKey: language === "en" ? "" : language,

  };

  try {
    const resData = await axios.post("UserFollow/UnfollowUser", data);
    console.log("Unfollow===>", resData);

    setToastMessage(resData.data.message);
    setShowToast(true);

    // update list state immediately
    // setPR((prevList) =>
    //   prevList.map((item) =>
    //     item.userUid === followedId
    //       ? { ...item, isFollowedByYou: false }
    //       : item
    //   )
    // );
  } catch (error) {
    if (error.response && error.response.status === 404) {
      setWarningToastMessage(error.response.data.message  );
      setShowWarningToast(true);
    } else if (error.response) {
      setErrorToastMessage(error.response.data?.message );
      setShowErrorToast(true);
    } else {
      setErrorToastMessage(error.response?.data?.message  );
      setShowErrorToast(true);
    }
  }
};

  //************************Cancel Request   ************************//
  const [show, setShow] = useState(false);
  const cancelRequestClose = () => {
    setShow(false);
  };
  // const [skillId, setSkillId] = useState("");
  const [userUID, setuserUID] = useState("");
  const CancelRequest = async (id) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: userUID,
            langKey: language === "en" ? "" : language,

    };
    // console.log(data);
    try {
      await axios
        .post("Connection/CancelConnectionRequest", data)
        .then((resData) => {
          // console.log(resData);
          setShow(!show);
          //   toast.success(resData.data.message);
          setToastMessage(resData.data.message);
          setShowToast(true);
          // setConnectedId(userUID);
          // SetIsConnected(false);
          // sentRequestList();
        });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Cancel Request ************************//
  // DS - 
  const openProfileHandler = (e, userUid) => {
    try {
      if (userUid) {
        navigate(`/User/${userUid}`);
      } else {
        setErrorToastMessage("User not found");
        setShowErrorToast(true);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleOpenChat = useCallback((e, userDetails) => {
    try {
      addChat(userDetails);
    } catch (error) {
      console.log(error);
    }
  }, [addChat])


  // const getMessageList = useCallback(async () => {
  //   const data = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //   };
  //   axios
  //     .post(`Message/GetMessageList`, data)
  //     .then((response) => {
  //       const res = response.data.responseData;
  //       setMessagesList(res);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     })
  // }, []);
 
//  useEffect(() => {
//   const sessionId = localStorage.getItem("sessionId");
//   if (sessionId) {
//     (async () => { 
//       await Promise.all([ 
//         getMessageList()
//       ]);
//     })();
//   } 
// }, []);
  // useEffect(() => {
  //     const sessionId = localStorage.getItem("sessionId");
  //     if(sessionId){
  //        getMessageList() 
  //     }
  //   }, [sessionId]);

   


  useEffect(() => {
    let cancelled = false;
    const unsubscribers = [];

    const setupHub = async () => {
      try {
        await startRealtimeHub();
      } catch (e) {
        console.log("Connection failed: ", e);
        return;
      }

      if (cancelled) return;

      unsubscribers.push(onHubEvent("ReplyChat", (message) => {
        let senderUid = localStorage.getItem("userUid");
        message.isOwned = senderUid === message.senderUid ? true : false;
        let userUid = message.isOwned ? message.receiverUid : message.senderUid;
        updateMessages(userUid, message);
      }));

      unsubscribers.push(onHubEvent("DeleteChat", (message) => {
        updateChatMessageByID(message);
      }));

      unsubscribers.push(onHubEvent("ReadChat", (message) => {
        // UnReadChat HTTP also emits ReadChat with isRead:false.
        if (message?.isRead === false || message?.isRead === "false") {
          updateChatUnreadStatus(message);
        } else {
          updateChatReadStatus(message);
        }
      }));

      unsubscribers.push(onHubEvent("ReadAllChat", (message) => {
        const payload = Array.isArray(message) ? message : [message];
        updateAllChatReadStatus(payload);
      }));
    };

    setupHub();

    return () => {
      cancelled = true;
      unsubscribers.forEach((unsubscribe) => unsubscribe());
    };
  }, []);

  // .....................................Chat
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      if (hoveredIndex !== null) {
        setHoveredIndex(null); // Hide tooltip on scroll
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hoveredIndex]);

  // .....................................View-Profile
  const [hoveredViewProfile, setHoveredViewProfile] = useState(null);

  useEffect(() => {
    const handleScroll1 = () => {
      if (hoveredViewProfile !== null) {
        setHoveredViewProfile(null); // Hide tooltip on scroll
      }
    };

    window.addEventListener("scroll", handleScroll1);
    return () => window.removeEventListener("scroll", handleScroll1);
  }, [hoveredViewProfile]);
// ............................................
  return (
    <>
      <div className="sideLinks rigtside-recommendation">
        {guestModeData === "true" ? (
          <div className="guest-right-sidebar">
            <div className="hashtags">
              <div className="sidebar-light-card sidebar-widget-card">
              <div className="header1 d-flex justify-content-between align-items-center">
                <h4 className="heading mb-0">{t("Sidemenubar.Top Users")} </h4>
              </div>
              <ul className="ps-0 listLink scroller">
                {isLoading ? (
                  <div className="mt-2">
                    <ShimmerDiv height={250} width={"100%"} />
                  </div>
                ) : (
                  ConnectionListForGuest &&
                  ConnectionListForGuest?.map((item, index) => {
                    return (
                      <>
                        <NavLink to={`/User/${item.userUid}`} key={index} target="blank">
                          <li className="navLinks d-flex align-items-center">
                            <div className="imgBg1">
                              <img
                                src={item.profilPic ? item.profilPic : people.DefaultProfile}
                                alt=""
                                width={35}
                                height={35}
                                style={{ borderRadius: "50px" }}
                                onError={handleProfileImageError}
                              />
                            </div>
                            <div>
                              {/* <span className="profile-name">
                                {item.fullName} */}
                              <span className="profile-name">{(item.fullName?.length > 15 ? item.fullName.slice(0, 15) + "..." : item.fullName)}
                              </span>
                              <p className="lastseen connectionFollower">
                                {item.followersCount} {t("My Connection.Followers")}
                              </p>
                            </div>
                          </li>
                        </NavLink>
                      </>
                    );
                  })
                )}
              </ul>
              </div>
            </div>
            <div className="hashtags">
              <div className="sidebar-light-card sidebar-widget-card">
              <div className="header1 d-flex justify-content-between align-items-center">
                <h4 className="heading mb-0">{t("Sidemenubar.Top Companies")}</h4>
              </div>
              <ul className="ps-0 listLink scroller">
                {isLoading ? (
                  <div className="mt-2">
                    <ShimmerDiv height={250} width={"100%"} />
                  </div>
                ) : (
                  compListForGuest &&
                  compListForGuest?.map((item, index) => {
                    return (
                      <>
                        <NavLink to={`/Company/${item.uid}`} key={index} target="blank">
                          <li className="navLinks d-flex align-items-center">
                            <div className="imgBg1">
                              <img
                                src={item.image}
                                alt=""
                                width={35}
                                height={35}
                                style={{ borderRadius: "50px" }}
                              />
                            </div>
                            <div>
                          <span className="profile-name">{(item.name?.length > 15 ? item.name.slice(0, 15) + "..." : item.name)}
                            </span>
                              {/* <span className="profile-name">{item.name}</span> */}
                              <p className="lastseen connectionFollower">
                                {item.followersCount} {t("My Connection.Followers")}
                              </p>
                            </div>
                          </li>
                        </NavLink>
                      </>
                    );
                  }
                )
                )}
              </ul>
              </div>
            </div>
          </div>
        ) : (
          <div className="right-sidebar-split">
            <div className="hashtags Recommendations-hashtags">
              <div className="sidebar-light-card sidebar-widget-card">
              <div className="header1 d-flex justify-content-between align-items-center">
                <h4 className="heading mb-0">{t("Recommendations.Recommendations")}</h4> 
                  {rightRecommendationList.length === 0 ? '' :
                <a
                  className="f-12 d-flex justify-content-center  pointer" style={{fontSize:'10px'}}
                  onClick={redirectToReceivedTab}
                > 
                  {t("Recommendations.View All")}
                </a>
                 }
              </div>
              <ul className="ps-0 listLink recommnedationLinks scroller1">
                {isLoading ? (
                  <div className="mt-2">
                    <ShimmerDiv height={50} width={"100%"} className="mb-2" />
                    <ShimmerDiv height={50} width={"100%"} className="mb-2" />
                    <ShimmerDiv height={50} width={"100%"} className="mb-2" />
                  </div>
                ) : isError || (rightRecommendationList?.length === undefined || rightRecommendationList?.length === 0) ? (
                  <div className="mt-2">
                    <img
                      src={post.errorSmall}
                      alt="404 Not Found"
                      width={200}
                    />
                    {/* <p className="f-14 mt-2">No Connections Found</p> */}
                  </div>
                ): (
                rightRecommendationList &&
                  rightRecommendationList?.slice(0, 8)?.map((item, index) => (
                    <li
                      className=" navLink d-flex   justify-content-between"
                      key={index}
                    >
                      <NavLink
                        to={`/User/${item.userUid}`} target="blank"
                        className="d-flex justify-content-between"
                        >
                        {!item.profilPic ? (
                          <div className="imgBg1">
                            <img
                              src={people.DefaultProfile}
                              alt=""
                              width={35}
                              height={35}
                              style={{ borderRadius: "50px" }}
                              onError={handleProfileImageError}
                            />
                          </div>
                        ) : (
                          <div className="imgBg1">
                            <img
                              src={item.profilPic}
                              alt=""
                              width={35}
                              style={{ borderRadius: "50px" }}
                              onError={handleProfileImageError}
                            />
                          </div>
                        )}
                        <div className="recomend-cont">
                          <div className="d-flex align-items-center justify-content-between">

                          <span className="profile-name">{(item.fullName?.length > 15 ? item.fullName.slice(0, 15) + "..." : item.fullName)} </span>
                          <div>
                        
                      </div>
                          </div>
                          <div className="text ms-1">
                            {item.followersCount} {t("My Connection.Followers")}
                          </div>
                          {shortMutualList[item.userUid] && (
                            <div className="d-flex mt-1 ms-0 Outercircle-container align-items-center">
                              <div className="circle-container">
                                {shortMutualList[item.userUid]?.pics?.map(
                                  (pic, picIndex) => (
                                    <img
                                      src={pic || people.DefaultProfile}
                                      alt={`Circle ${picIndex + 1}`}
                                      className="circle-img"
                                      key={picIndex}
                                      onError={handleProfileImageError}
                                    />
                                  )
                                )}
                              </div>
                              {/* <div className="text">
                                {shortMutualList[item.userUid]?.text}
                              </div> */}
                              <div className={`f-12 text AddSpaceMargin ${shortMutualList?.[item.userUid]?.count === 1 ? 'ms-2' : 'ms-0'}`} >
                                {/* {shortMutualList[item.userUid]?.text} */}
                           {(shortMutualList[item.userUid]?.text?.length > 15 ? shortMutualList[item.userUid]?.text.slice(0, 15) + "..." : shortMutualList[item.userUid]?.text)}

                              </div>
                            </div>
                          )}
                        </div>
                      </NavLink>
                      
                      <div
                          onClick={() => toggleDropdown(index)}
                          className="postMenu"
                        >

                          <MoreHorizSharpIcon className="material-symbols-sharp" />
                          {openDropdown === index && (
                            <Dropdown.Menu
                              show={openDropdown === index}
                              ref={(el) => (dropdownRefs.current[index] = el)}
                              className="InteractionModal"
                              align="start"
                            >
                              {item.isFollowedByYou === true ||
                                (followedId === item?.userUid &&
                                  isfollowed === true) ? (
                                 <Dropdown.Item
                                  as="button"
                                  className="dropdownList p-0"
                                  onClick={() => {
                                    setShowFollowModal(true);;
                                    setFollowedId(item.userUid);
                                  }}
                                >
                                  <div className="d-flex align-items-center">
                                    <span className="dropdownTxt f-14">
                                     {/* Unfollow */}
                                     {t("Recommendations.Unfollow")}
                                    </span>
                                  </div>
                                </Dropdown.Item>
                              ) : (
                                <Dropdown.Item
                                  as="button"
                                  className="dropdownList p-0"
                                  onClick={() => {
                                    handleRecommendFollow(item);
                                    setFollowedId(item.userUid);
                                  }}
                                >
                                  <div className="d-flex align-items-center">
                                    <span className="dropdownTxt f-14">
                                      {/* Follow */}
                                      {t("Recommendations.Follow")}
                                    </span>
                                  </div>
                                </Dropdown.Item>
                              )}

                              <Dropdown.Divider />
                              {item.isConnectedByYou === true ||
                                (connectedId === item?.userUid &&
                                  isConnected === true) ? (
                                <Dropdown.Item
                                  as="button"
                                  className="dropdownList p-0"
                                >
                                  <div
                                    onClick={() => {
                                      setShow(!show);
                                      setuserUID(item.userUid);
                                      setConnectedId(item?.userUid);
                                    }}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span className="dropdownTxt f-14">
                                        {t("Recommendations.Cancel Request")}
                                      </span>
                                    </div>
                                  </div>
                                </Dropdown.Item>
                              ) : (
                                <Dropdown.Item
                                  as="button"
                                  className="dropdownList p-0"
                                >
                                  <div
                                    onClick={() => {
                                      handleRecommendConnect(item);
                                      // setConnectedId(item?.userUid);
                                    }}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span className="dropdownTxt f-14">
                                        {/* Connect */}
                                        {t("Recommendations.Connect")}
                                      </span>
                                    </div>
                                  </div>
                                </Dropdown.Item>
                              )}
                            </Dropdown.Menu>
                          )}
                        </div>
                    </li>
                    
                  
                  )
                ))
                  }
                  {rightRecommendationList.length === 0 ? '' :
                <a
                  className="f-14 d-flex justify-content-center mt-2 pointer" 
                  onClick={redirectToReceivedTab}
                >
               {t("Recommendations.View All")}
                </a>
}
              </ul>
              </div>
            </div>
            <div className="hashtags">
              <div className="sidebar-light-card sidebar-widget-card">
              <div className="header1 d-flex justify-content-between align-items-center">
                <h4 className="heading mb-0">{t("My Connection.My Connection")} </h4>
                {RightConnectionList.length === 0 ? '' : <a
                      className="f-14 d-flex justify-content-center pointer"
                      onClick={redirectToConnectionTab} style={{fontSize:'10px'}}
                    >
                   {t("My Connection.View All")}
                    </a>}
              </div>
              <ul className="ps-0 listLink scroller">
                {/* {console.log(searchconnectList?.length, ConnectionList?.length)} */}

                {isLoading ? (
                  <div className="mt-2">
                    <ShimmerDiv height={50} width={"100%"} className="mb-2" />
                    <ShimmerDiv height={50} width={"100%"} className="mb-2" />
                    <ShimmerDiv height={50} width={"100%"} className="mb-2" />
                    
                  </div>
                ) : 
                isError1
                //  || 
                // (rightSearchconnectList?.length === undefined || RightConnectionList?.length === 0) ? (
                  // (rightSearchconnectList?.length === undefined || rightSearchconnectList?.length === 0) ?(
                  ? (
                  <div className="mt-2">
                    <img
                      src={post.errorSmall}
                      alt="404 Not Found"
                      width={200}
                    />
                    {/* <p className="f-14 mt-2">No Connections Found</p> */}
                  </div>
                  ) : rightSearchconnectList?.length === 0 ? (
                  <>
                    {RightConnectionList?.slice(0, 5)?.map((item, index) => (
                      <li className="navLinks d-flex align-items-center">
                        <div className="imgBg1">
                          <div className="d-flex">

                          <NavLink to={`/User/${item.userUid}`} key={index} target="blank">            
                            <img
                              src={item.profilPic ? item.profilPic : people.DefaultProfile}
                              alt=""
                              width={35}
                              height={35}
                              style={{ borderRadius: "50px" }}
                              onError={handleProfileImageError}
                            />

                          </NavLink> 
                                {item.isOnline === true ? (
                                  <>
                                  <div style={{position:'relative', left:'-9px', top: '-8px'}}>
                                   <CircleIcon style={{   
                                          color: 'rgb(41, 205, 41)',
                                       background :' rgb(41, 205, 41)',
                                        borderRadius:' 50%',
                                        width: '9px',
                                        height: '9px',
                                        border: '1px solid white',                    
                                        boxShadow: '1px 1px 6px 1px white',
                                   }}/> 
                                  </div>       
                                  </>
                                ): ''} 
                          </div>

                        </div>
                        {/* <div> */}
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start", width: "100%"}}>                    
                          <div>                    
                            <NavLink to={`/User/${item.userUid}`} key={index} target="blank">            
                              {/* <div className="profile-name"> */}
                                {/* {item.fullName} */}
                          <span className="profile-name">{(item.fullName?.length > 15 ? item.fullName.slice(0, 10) + "..." : item.fullName)}
                          </span>
                              {/* </div>  */}
                            </NavLink>
                            
                            <p className="lastseen connectionFollower">
                              {item.followersCount} {t("My Connection.Followers")}
                            </p>
                          </div>
                          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                              <Tooltip title={t("My Connection.Chat")} arrow
                                 key={index} 
                              open={hoveredIndex === index}
                              onOpen={() => setHoveredIndex(index)}
                              onClose={() => setHoveredIndex(null)}
                              > 
                              <MailOutlineSharpIcon
                                onClick={(e) => { handleOpenChat(e, item) }}
                                className="material-symbols-sharp"
                                 onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}

                                />
                              </Tooltip>
                              <Tooltip title={t("My Connection.View Profile")} arrow
                              key={index} 
                               open={hoveredViewProfile === index}
                              onOpen={() => setHoveredViewProfile(index)}
                              onClose={() => setHoveredViewProfile(null)}
> 
                              <PersonSharpIcon
                                onClick={(e) => { openProfileHandler(e, item?.userUid) }}
                                className="material-symbols-sharp"
                                onMouseEnter={() => setHoveredViewProfile(index)}
                                onMouseLeave={() => setHoveredViewProfile(null)}

                              />
                              </Tooltip>
                            </div>
                        </div>
                      </li>
                    ))}
                    {RightConnectionList.length === 0 ? '' : <a
                      className="f-14 d-flex justify-content-center mt-2 pointer"
                      onClick={redirectToConnectionTab}
                      >
                       {t("My Connection.View All")}
                       </a>}
                      </>
                   ) : <>
                  {rightSearchconnectList?.slice(0, 5)?.map((item, index) => (
                    <> 
                    
                      <li className="navLinks d-flex align-items-center">
                        <div className="imgBg1">
                          <div className="d-flex">

                          <NavLink to={`/User/${item.userUid}`} key={index} target="blank">            
                            <img
                              src={item.profilPic ? item.profilPic : people.DefaultProfile}
                              alt=""
                              width={35}
                              height={35}
                              style={{ borderRadius: "50px" }}
                              onError={handleProfileImageError}
                            />

                          </NavLink> 
                                {item.isOnline === true ? (
                                  <>
                                  <div style={{position:'relative', left:'-9px', top: '-8px'}}>
                                   <CircleIcon style={{   
                                          color: 'rgb(41, 205, 41)',
                                       background :' rgb(41, 205, 41)',
                                        borderRadius:' 50%',
                                        width: '9px',
                                        height: '9px',
                                        border: '1px solid white',                    
                                        boxShadow: '1px 1px 6px 1px white',
                                   }}/> 
                                  </div>       
                                  </>
                                ): ''} 
                          </div>

                        </div>
                        {/* <div> */}
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start", width: "100%"}}>                    
                          <div  >                    
                            <NavLink to={`/User/${item.userUid}`} key={index} target="blank">            
                              {/* <div className="profile-name">
                                {item.fullName}
                              </div>  */}
                          <span className="profile-name">{(item.fullName?.length > 15 ? item.fullName.slice(0, 15) + "..." : item.fullName)}
                          </span>
                            </NavLink>
                            
                            <p className="lastseen connectionFollower">
                              {item.followersCount} {t("My Connection.Followers")}
                            </p>
                          </div>
                          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                              <Tooltip title="Chat" arrow
                                 key={index} 
                              open={hoveredIndex === index}
                              onOpen={() => setHoveredIndex(index)}
                              onClose={() => setHoveredIndex(null)}
                              > 
                              <MailOutlineSharpIcon
                                onClick={(e) => { handleOpenChat(e, item) }}
                                className="material-symbols-sharp"
                                 onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}

                                />
                              </Tooltip>
                              <Tooltip title="View Profile" arrow
                              key={index} 
                               open={hoveredViewProfile === index}
                              onOpen={() => setHoveredViewProfile(index)}
                              onClose={() => setHoveredViewProfile(null)}
> 
                              <PersonSharpIcon
                                onClick={(e) => { openProfileHandler(e, item?.userUid) }}
                                className="material-symbols-sharp"
                                onMouseEnter={() => setHoveredViewProfile(index)}
                                onMouseLeave={() => setHoveredViewProfile(null)}

                              />
                              </Tooltip>
                            </div>
                        </div>
                      </li>
                    </>
                  ))}

                </>
                }
              </ul>

            <div className="search-container connection-search-bar">
              <SearchSharpIcon className="material-symbols-sharp" />
              <div className="search-input-container">
                <input
                  type="text"
                  className="form-control connection-input search-input"
                  aria-label={t("Newsfeed.Search Connections")}
                  placeholder={t("Newsfeed.Search Connections")}
                  onChange={(e) => {
                    setRightSearchUserName(e.target.value);
                  }}
                  value={rightSearchUserName}
                />
              </div>
            </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {show && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Are You Sure You want to Cancel Request?")}</h6>

                {/* <span
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    cancelRequestClose();
                  }}
                >
                  close
                </span> */}
                <CloseSharpIcon className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    cancelRequestClose();
                  }} />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => CancelRequest()}
                >
                 {t("modals.Yes")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

        {showfollowModal && (
              <div
                className="modal fade show postAdd"
                tabIndex="-1"
                role="dialog"
                style={{ display: "block" }}
              >
                <div className="modal-dialog  modal-dialog-centered " role="document">
                  <div className="modal-content d-flex justify-content-around p-2">
                    <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                      <h6>
                        {t("modals.Are you sure you want to unfollow")}     
                      </h6>
      
                      {/* <span
                       
                      >
                        close
                      </span> */}
                      <CloseSharpIcon 
                       className="material-symbols-sharp me-2 pointer"
                        onClick={() => {
                          handleUnfollowCloseModal();
                        }} />
                    </div>
      
                    <div className="text-center mt-2">
                      <button
                        color=""
                        className="closebtn"
                        onClick={() => handleConfirmAction()}
                      >
                         {t("Recommendations.Unfollow")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}


      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
      {unauthorisedModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="d-flex justify-content-between align-items-center p-2">
                <div>
                  <h4 className="text-center AdBlocker">{t("Recommendations.Warning")}</h4>
                  <p className="text-center ad-p">
                    {t("modals.Your session has expired or you are not authorized to access this resource. Please log in again to continue.")}
                  </p>
                  <div className="text-center m-auto mt-3">
                    <button
                      type="button"
                      className="mainBtn1 "
                      onClick={() => {
                        setUnauthorisedModal(!unauthorisedModal)
                        navigate("/SignIn");
                        localStorage.clear();
                        sessionStorage.removeItem('hasModalShown');
                      }}
                    >
                      {t("modals.login")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RightNavigation;
